import { useState,useEffect } from "react";
import { useParams } from "react-router-dom";
import useCurrentUserProfile from "../../../../hooks/useCurrentUserProfile";
import axios from "axios";
import UniversityTeachers from "../teachers/UniversityTeachers";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const UniversityDashboard = () => {
  const {profile,fetchProfile} = useCurrentUserProfile()
  const {university_name,dean_name,department_name}=useParams()
  const [labs, setLabs] = useState([]);
  const [lab_groups, setLabGroups] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [email,setEmail] = useState("")
  const [paymentStatus, setPaymentStatus] = useState("pending");
  const [open, setOpen] = useState(false);

useEffect(() => {
  if (paymentStatus === "pending") return;
  fetchProfile()
}, [paymentStatus]);

    // console.log("The teachers are:",profile)
    const fetchTeachers = async () => {
      try {
        const res = await axios.get(
          `${BASE_URL}/teacher/university/teacher/`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
              "x-api-key": process.env.REACT_APP_X_API_KEY,
            },
          }
        );
        setTeachers(res?.data || []);
      } catch (error) {
        console.log("Error while getting profiles", error);
        setTeachers([]);
      }
    };
  
    useEffect(() => {
      fetchTeachers();
    }, []);
  
 const [deans, setDeans] = useState([]);
   const fetchDeans = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/marketplace/university/dean/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        });
        setDeans(res?.data || []);
      } catch (error) {
        console.log("Error while getting profiles", error);
        setDeans([]);
      }
    };
  useEffect(() => {
    fetchDeans();
  }, []);
  // console.log("The lab groups are:",lab_groups)

  const fetchDepartments = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/marketplace/university/department/`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        }
      );
      setDepartments(res?.data || []);
    } catch (error) {
      console.log("Error while getting profiles", error);
      setDepartments([]);
    }
  };

  useEffect(() => {
    fetchDepartments();
  }, []);
  
   // ------------------------ HANDLE WITHDRAW ------------------------
const handleWithDraw = async () => {
  if (!email) return alert("Email is required");

  // Calculate remaining withdrawable amount
  const remainingAmount =
  Number(profile?.university_data?.total_earned || 0) -
  Number(profile?.university_data?.withdraw_amount || 0);
  
  if (!remainingAmount || remainingAmount < 1)
    return alert("Minimum amount required is $1");

  setLoading(true);

  try {
    // Step 1: Update PayPal email & set payout_status to "pending"
    const updateRes = await fetch(`${BASE_URL}/marketplace/university/${profile?.university_data?.id}/update/`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        "x-api-key": process.env.REACT_APP_X_API_KEY,
      },
      body: JSON.stringify({ paypal_email: email, payout_status: "pending" }),
    });

    if (!updateRes.ok) throw new Error("Failed to update PayPal email");

    // Step 2: Trigger payout with correct remaining amount
    const payoutRes = await fetch(`${BASE_URL}/paypal/withdraw-payout/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        "x-api-key": process.env.REACT_APP_X_API_KEY,
      },
      body: JSON.stringify({ 
        paypal_email: email, 
        amount: Number(remainingAmount.toFixed(2)) // send only remaining balance
      }),
    });

    if (!payoutRes.ok) throw new Error("Failed to process payout");

    // Step 3: Poll teacher status until webhook updates (up to 1 minute)
    const startTime = Date.now();
    const timeout = 60000; // 60 seconds
    let payoutStatus = "pending";

    while (payoutStatus === "pending" && Date.now() - startTime < timeout) {
      await new Promise(r => setTimeout(r, 2000)); // 2s interval

      try {
        const statusRes = await fetch(`${BASE_URL}/marketplace/university/${profile?.university_data?.id}/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        });

        if (!statusRes.ok) continue; // skip this iteration if error

        const statusData = await statusRes.json();

        // Ensure we default to "pending" if webhook hasn't updated yet
        payoutStatus = statusData?.payout_status ?? "pending";

        console.log("Polling status:", payoutStatus, "Elapsed:", Date.now() - startTime);
      } catch (err) {
        console.warn("Error fetching status, retrying...", err);
      }
    }

    // Step 4: Handle final payout status
    if (payoutStatus === "complete") {
      alert("✅ Payment completed successfully");
      setPaymentStatus("complete")
      fetchProfile();
    } else if (payoutStatus === "unclaimed") {
      setPaymentStatus("unclaimed")
      alert("⚠️ Payment is unclaimed, please check your PayPal account.");
    } else if (payoutStatus === "failed") {
      alert("❌ Payment failed, please try again.");
      setPaymentStatus("failed")
    } else {
      // alert("⏱ Payment processing timeout, please check later."); // only after 60s
      alert("⏱ Payment done successfully. if payment not updated please refersh the page"); // only after 60s
      setPaymentStatus("complete")
      fetchProfile();
      window.location.reload()
    }

  } catch (err) {
    console.error(err);
    alert("Something went wrong. Please try again.");
  } finally {
    setLoading(false);
    setOpen(false);
  }
};

  return (
    <div className="min-h-screen">
      {/* Dashboard Card */}
      <div className="">
        <div className="">
          
          {/* Header with Icon */}
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-12 bg-[#e8f0f7] rounded-xl flex items-center justify-center">
              <svg className="w-6 h-6 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
            </div>
            <div>
            <h1 className="text-2xl font-semibold text-gray-900">
  <span className="font-bold text-cyan-500">
    {profile?.name}
  </span>{" "}
  Head Of{" "}
  <span className="font-bold text-blue-600">
    {profile?.university_data?.university_name}
  </span>
</h1>
              <p className="text-sm text-gray-500 mt-1">
                Welcome to your dashboard. You are managing this laboratory and its activities.
              </p>
            </div>
          </div>

          {/* Info Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {/* Laboratory */}
            <div className="bg-white p-4 rounded-xl border border-gray-200 hover:border-[#0f6abf] transition-colors">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
                 <svg className="w-4 h-4 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </div>
                <div>
                  <p className="text-xs text-gray-500">Deans</p>
                  <p className="text-sm font-medium text-gray-900">{deans?.length} Deans</p>
                </div>
              </div>
            </div>

            {/* Groups */}
            <div className="bg-white p-4 rounded-xl border border-gray-200 hover:border-[#0f6abf] transition-colors">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
                  <svg className="w-4 h-4 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
                <div>
                  <p className="text-xs text-gray-500">Departments</p>
                  <p className="text-sm font-medium text-gray-900">{departments?.length} Departments</p>
                </div>
              </div>
            </div>

            {/* Teachers */}
            <div className="bg-white p-4  rounded-xl border border-gray-200 hover:border-[#0f6abf] transition-colors">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
                <svg
  className="w-4 h-4 text-[#0f6abf]"
  fill="none"
  stroke="currentColor"
  viewBox="0 0 24 24"
>
  <path
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5 5.015 5 3 6.567 3 8.5v11c0-1.933 2.015-3.5 4.5-3.5 1.746 0 3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5 18.985 5 21 6.567 21 8.5v11c0-1.933-2.015-3.5-4.5-3.5-1.746 0-3.332.477-4.5 1.253"
  />
</svg>
                </div>
                <div>
                  <p className="text-xs text-gray-500">Teachers</p>
                  <p className="text-sm font-medium text-gray-900">{teachers?.length} Teachers</p>
                </div>
              </div>
            </div>
       

          </div>
          {/* University Commission Header */}
          <div className="flex items-center gap-3 mb-6 mt-6">

  <div className="w-12 h-12 bg-[#e8f0f7] rounded-xl flex items-center justify-center">
    <svg
      className="w-6 h-6 text-[#0f6abf]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M3 21h18M5 21V7l7-4 7 4v14M9 21v-8h6v8"
      />
    </svg>
  </div>

  <div>
    <h1 className="text-2xl font-semibold text-gray-900">
      University Commission
    </h1>

    <p className="text-sm text-gray-500 mt-1">
      Manage earnings generated from teachers’ courses. Your university receives a commission share from every paid enrollment.
    </p>
  </div>

</div>
   {/* University  Commission  Grid */}
   <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">

  {/* TOTAL INCOME */}
  <div className="bg-white p-4 rounded-xl border border-gray-200 hover:border-[#0f6abf] transition-colors">
    <div className="flex items-center gap-3">

      <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
        <svg className="w-4 h-4 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
            d="M12 8c-3 0-6 1.5-6 4s3 4 6 4 6 1.5 6 4-3 4-6 4M12 2v4" />
        </svg>
      </div>

      <div>
        <p className="text-xs text-gray-500">Total Income</p>
        <p className="text-sm font-medium text-gray-900">
          $ {profile?.university_data?.total_earned || 0}
        </p>
      </div>

    </div>
  </div>

  {/* WITHDRAW AMOUNT */}
       <div className="bg-white p-4 rounded-xl border border-gray-200 hover:border-[#0f6abf] transition-colors">

  <div className="flex items-center justify-between gap-3">

    {/* LEFT SIDE */}
    <div className="flex items-center gap-3">

      <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
        <svg
          className="w-4 h-4 text-[#0f6abf]"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 1v22m5-18H9.5a3.5 3.5 0 100 7H14a3.5 3.5 0 110 7H7"
          />
        </svg>
      </div>

      <div>
        <p className="text-xs text-gray-500">Withdraw Amount</p>
        <p className="text-sm font-medium text-gray-900">{`$ ${Number(profile?.university_data?.withdraw_amount || 0).toFixed(2)}`}</p>
      </div>

    </div>

    {/* RIGHT SIDE - WITHDRAW BUTTON */}
     <button onClick={() => setOpen(true)} className="mt-2 px-8 py-2.5 bg-[#0f6abf] text-white font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2">
                  Withdraw
                </button>

  </div>
</div>
  {/* REMAINING BALANCE */}
  <div className="bg-white p-4 rounded-xl border border-gray-200 hover:border-[#0f6abf] transition-colors">
    <div className="flex items-center gap-3">

      <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
        <svg className="w-4 h-4 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
            d="M12 8c-2.5 0-4 1.5-4 3s1.5 3 4 3 4 1.5 4 3-1.5 3-4 3m0-18v2m0 16v2" />
        </svg>
      </div>

      <div>
        <p className="text-xs text-gray-500">Remaining Balance</p>
        <p className="text-sm font-medium text-gray-900">
          {`$ ${(Number(profile?.university_data?.available_balance || 0)).toFixed(2)}`}
        </p>
      </div>

    </div>
  </div>

</div>
 
      
        </div>
      </div>
       <UniversityTeachers hide={true}/>
        {/* Withdraw Modal */}
      {open && (
        <>
          <div onClick={() => setOpen(false)} className="fixed inset-0 bg-black/50 z-40" />
          <div className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-2xl shadow-xl w-[90%] max-w-md z-50">
            <div className="p-6 border-b border-gray-100 flex items-center justify-between">
              <h2 className="text-lg font-semibold text-gray-900">Withdraw Amount</h2>
              <button onClick={() => setOpen(false)} className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors">
                <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div className="p-6">
              <p className="text-sm text-gray-600 mb-4">Enter your PayPal email to withdraw the amount.</p>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Enter your PayPal email" className="w-full px-4 py-3 mb-4 bg-gray-50 border border-gray-300 rounded-xl focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all" />
              <button onClick={handleWithDraw}  disabled={loading} className="w-full py-3 bg-[#0f6abf] text-white font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2">
                {loading ? <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div> : "Withdraw Amount"}
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default UniversityDashboard;